module.exports = __webpack_public_path__ + "static/assets/47564d55678ea63da6453540ac803eee.svg";